module.exports = __webpack_public_path__ + "static/media/thor.2ee7e899.png";